import React from 'react';
import styled from 'styled-components';
import { colors, fonts } from '../styles/globals';

const AboutContainer = styled.section`
  background-color: ${colors.white};
  padding: 80px 20px;
  text-align: center;

  @media (max-width: 768px) {
    padding: 60px 20px;
  }
`;

const AboutContent = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

const AboutText = styled.div`
  text-align: left;
`;

const AboutTitle = styled.h2`
  font-family: ${fonts.playfair};
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  color: ${colors.primary};
  margin-bottom: 16px;
  line-height: 1.2;
`;

const AboutSubtitle = styled.p`
  font-family: ${fonts.inter};
  font-size: 1.2rem;
  font-weight: 500;
  color: ${colors.text};
  margin-bottom: 40px;
  line-height: 1.5;
`;

const AboutCard = styled.div`
  background: linear-gradient(135deg, ${colors.background} 0%, #F8FBFF 100%);
  border-radius: 20px;
  padding: 40px;
  border-left: 4px solid ${colors.accent};
  text-align: left;

  @media (max-width: 768px) {
    padding: 30px 20px;
  }
`;

const AboutDescription = styled.p`
  font-family: ${fonts.inter};
  font-size: 1.1rem;
  color: ${colors.text};
  line-height: 1.6;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const AboutHighlight = styled.span`
  color: ${colors.primary};
  font-weight: 600;
`;

const AboutImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    order: -1;
  }
`;

const ImageContainer = styled.div`
  width: 350px;
  height: 400px;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);

  @media (max-width: 768px) {
    width: 280px;
    height: 320px;
  }
`;

const ImageElement = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
`;

function AboutEduardoSection() {
  return (
    <AboutContainer>
      <AboutContent>
        <AboutText>
          <AboutTitle>Sobre Eduardo Gaoch</AboutTitle>
          <AboutSubtitle>
            Coach conversacional especializado en liberar la voz auténtica
          </AboutSubtitle>

          <AboutCard>
            <AboutDescription>
              <AboutHighlight>Eduardo Gaoch</AboutHighlight> es un coach conversacional que ha dedicado su vida a ayudar a las personas a liberar su voz auténtica y superar los bloqueos emocionales que les impiden comunicarse con poder y autenticidad.
            </AboutDescription>
            
            <AboutDescription>
              Con más de 10 años de experiencia en comunicación y transformación personal, Eduardo ha desarrollado una metodología única que combina técnicas de oratoria con sanación emocional, permitiendo a sus estudiantes no solo aprender a hablar mejor, sino a <AboutHighlight>hablar desde su verdad interior</AboutHighlight>.
            </AboutDescription>
            
            <AboutDescription>
              Su enfoque se centra en que cada persona conecte con su historia personal y la use como fuente de poder, transformando el miedo escénico en una oportunidad para impactar y conectar genuinamente con su audiencia.
            </AboutDescription>
          </AboutCard>
        </AboutText>

        <AboutImage>
          <ImageContainer>
            <ImageElement
              src="/images/eduardo-about.jpg"
              alt="Eduardo Gaoch - Coach en Oratoria"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            <div style={{ 
              display: 'none', 
              width: '100%', 
              height: '100%', 
              background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.darkBackground} 100%)`,
              borderRadius: '20px',
              alignItems: 'center',
              justifyContent: 'center',
              color: colors.white,
              fontSize: '3rem'
            }}>
              🎤
            </div>
          </ImageContainer>
        </AboutImage>
      </AboutContent>
    </AboutContainer>
  );
}

export default AboutEduardoSection; 